/**
 * 模板
 */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './TempModal.module.scss';
import http from '@/assets/api/http';
import CusotmUpload from '@/components/NewUpload';
import model from '@/reducers/contract/templatetrac/model';
import { connect } from 'react-redux';
import {
    Modal,
    message,
    Form,
    Input,
    Select,
} from 'antd';

const FormItem = Form.Item;
const { Option } = Select;
const layout = {
    labelCol: {
        span: 5,
        offset: 2
    },
    wrapperCol: {
        span: 19,
    },
};


const TempModal = ({
    closeMode,
    getTemptracName,
    temptracName,
    ...restProps
}) => {

    const [title, setTitle] = useState(restProps.title);
    const [visible, setVisible] = useState(restProps.visible);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        getTemptracName({ enumName: 'FadadaContractCodeEnum' });//模板名称
    }, []);


    const _handleOk = () => {
        form.validateFields().then((values) => {
            let {
                tempName,
                version,
                template,
            } = values;

            let submitData = {
                code: tempName,
                version,
                url: template[0].url,
            };
            setConfirmLoading(true);
            http('/?cmd=com.xqxc.api.pig.mis.biz.platform.FadadaMisService.uploadTemplate', submitData, 'POST').then(() => {
                message.success('上传成功');
                setVisible(false);
                closeMode(true);
            }).catch((e = {}) => {
                message.error(e.message || '提交异常');
                setConfirmLoading(false);
            });
        }).catch(() => { });
    }

    const _handleCancel = () => {
        setVisible(false);
        closeMode();
    }

    //图片
    const onFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    return (
        <Modal
            width={520}
            centered
            title={title}
            visible={visible}
            confirmLoading={confirmLoading}
            onOk={_handleOk}
            onCancel={_handleCancel}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
        >

            <Form
                {...layout}
                className={styles.container}
                autoComplete='off'
                name="create"
                scrollToFirstError
                form={form}
            >
                <FormItem
                    name="tempName"
                    label='模板名称'
                    colon={false}
                    rules={[{ required: true, message: '请选择' }]}>
                    <Select
                        showSearch
                        style={{ width: '270px' }}
                        placeholder="请选择"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {temptracName.map(v => <Option key={v.code} value={v.code}>{v.value}</Option>)}
                    </Select>
                </FormItem>
                <FormItem
                    name="version"
                    label="版本号"
                    colon={false}
                    rules={[
                        {
                            required: true, pattern: /^(V|v)([1-9]\d|[1-9])(.([1-9]\d|\d)){2}$/, message: '请输入版本号'
                        },
                    ]}
                >
                    <Input
                        style={{ width: 270 }}
                        placeholder="请输入(例v1.0.0)"
                        suffix={<FormItem
                            noStyle
                            shouldUpdate
                        >
                            {({ getFieldValue }) => {
                                return getFieldValue('version') ? (
                                    <span key={getFieldValue('version')}>{getFieldValue('version').length}/20</span>
                                ) : <span>0/20</span>;
                            }}
                        </FormItem>}
                        maxLength={20}
                    />
                </FormItem>
                <FormItem
                    name="template"
                    label='上传模板'
                    colon={false}
                    valuePropName='fileList'
                    getValueFromEvent={onFile}
                    rules={[{ type: 'array', required: true, message: '上传模板' }]}
                >
                    <CusotmUpload
                        accept='.pdf, .PDF'
                        listType="picture-card"
                        wallMode='single'
                        removeError
                        qiniuUploadProps={{ uploadType: 'image' }}
                        beforeUpload={file => {
                            const isType = ['application/pdf', 'application/PDF'];
                            if (!isType.includes(file.type)) {
                                message.warning('只能上传 .pdf, .PDF 格式的文件!');
                                file.status = 'error';
                                return false;
                            }
                        }}
                    >
                        <div style={{ color: '#999', fontSize: '12px' }}>上传图片</div>
                    </CusotmUpload>
                </FormItem>
            </Form>
        </Modal>
    );

}

TempModal.propTypes = {
    data: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object
    ]), // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
    temptracName: PropTypes.array,
    getTemptracName: PropTypes.func,//模板名称下拉数据(action)
};

const mapStateToProps = (state) => {
    return {
        temptracName: state.templatetrac.temptracName,
    };
};

export default connect(mapStateToProps, model.actions)(TempModal);